/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class EmailablePayloadWithContactsMapDTO<T> extends JSONable {

  payload: T | undefined = undefined;
  contactUuids?: {[key: string]: string[]};

  constructor(private payloadType?: new () => T) {
    super();
    if(payloadType) {
      this.payload = new payloadType;
    }
    this.contactUuids = {};
  }

}
